import { supabase } from '@/lib/supabase';
import { unwrap } from '@/data/serviceError';
import type { Gebeurtenis } from '../lib/gebeurtenissen';

/**
 * Tijdlijn per melding of bouwpunt (tabel melding_gebeurtenissen). Alleen
 * lezen: de database vult de tabel via triggers, en de RLS bepaalt wat je
 * ziet (melder: eigen melding zonder interne regels; beheerder/meekijker: alles).
 */
export const meldingGebeurtenissenService = {
  async voorMelding(meldingId: string): Promise<Gebeurtenis[]> {
    return unwrap(
      await supabase
        .from('melding_gebeurtenissen')
        .select('*')
        .eq('melding_id', meldingId)
        .order('created_at')
        .order('nr'),
      'Tijdlijn laden',
    );
  },

  async voorBouwpunt(bouwpuntId: string): Promise<Gebeurtenis[]> {
    return unwrap(
      await supabase
        .from('melding_gebeurtenissen')
        .select('*')
        .eq('bouwpunt_id', bouwpuntId)
        .order('created_at')
        .order('nr'),
      'Tijdlijn laden',
    );
  },
};
